import { ScoreWithFixAndNoFix, SimpleScore } from '@internal/ui-common';

export function sortSimpleScore(s1: SimpleScore, s2: SimpleScore): number {
  if (s2.red !== s1.red) return s2.red - s1.red;
  if (s2.orange !== s1.orange) return s2.orange - s1.orange;
  if (s2.green !== s1.green) return s2.green - s1.green;
  return 0;
}

export function sortFixNoFixScore(
  s1: ScoreWithFixAndNoFix,
  s2: ScoreWithFixAndNoFix,
): number {
  if (s2.red.fix !== s1.red.fix) return s2.red.fix - s1.red.fix;
  if (s2.orange.fix !== s1.orange.fix) return s2.orange.fix - s1.orange.fix;
  return 0;
}
